import { styled } from '@vebox/etui-system';
import '../../utilities/format-ms.js';
import '../../utilities/create-transition.js';
import { createElement } from 'react';
import '../../utilities/get-styleprop.js';
import { a as _objectSpread2, b as _extends } from '../../_rollupPluginBabelHelpers-3b7bd988.js';
import { Div, Span } from '@vebox/etui-system-elements';
import '../../Svg-0180d7b5.js';
import Icon from '../../Icon/Icon.js';
import '@vebox/etui-icons';
import '../../Icon/icons.js';
import '../../Icon/helper.js';
import '@vebox/etui-colors';
import 'react-dom';
import '../../ClickOutside/ClickOutside.js';
import '../../Tooltip/Tooltip.js';
import '../../Button/Button.js';
import 'react-popper';
import '../../DropdownMenu/DropdownMenu.js';
import '../../DropdownMenu/Item.js';
import '../../DropdownMenu/Divider.js';
import { colors } from '../colors.js';
import FavoriteStar from './FavoriteStar.js';
import ItemDropdown from './ItemDropdown.js';

const ItemWrapper = styled(Div).attrs(props => _objectSpread2({}, props))`
  position: relative;
  width: 96px;
  height: 96px;
`;

const Title = styled(Span)`
  color: ${({
  theme
}) => theme.palette.common.white};
  text-align: center;
`;

const Item = styled(Div)`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  cursor: pointer;

  :hover {
    background-color: ${colors.itemHover};
  }

  :active {
    background-color: ${({
  theme
}) => theme.palette.black[100]};
  }
`;

const Item$1 = ({
  icon,
  title,
  onClick,
  onMarkFavorite,
  onUnmarkFavorite,
  markFavoriteLabel,
  unmarkFavoriteLabel,
  isFavorite
}) => {
  var _icon$styles;
  return /*#__PURE__*/createElement(ItemWrapper, null, isFavorite && /*#__PURE__*/createElement(FavoriteStar, null), /*#__PURE__*/createElement(ItemDropdown, {
    onMarkFavorite: onMarkFavorite,
    onUnmarkFavorite: onUnmarkFavorite,
    markFavoriteLabel: markFavoriteLabel,
    unmarkFavoriteLabel: unmarkFavoriteLabel,
    isFavorite: isFavorite
  }), /*#__PURE__*/createElement(Item, {
    onClick: onClick
  }, /*#__PURE__*/createElement(Icon, _extends({
    size: 48
  }, icon, {
    styles: {
      root: _objectSpread2({
        color: 'white'
      }, (_icon$styles = icon.styles) === null || _icon$styles === void 0 ? void 0 : _icon$styles.root)
    }
  })), /*#__PURE__*/createElement(Title, null, title)));
};

export default Item$1;
